import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

/*
 * Site footer.
 *
 * The reference mock carried Privacy Policy, Terms of Service, Support and
 * Contact Us. None of those pages exist in this app, and four links to
 * nowhere read worse than none at all, so this carries the routes that are
 * actually real.
 */
export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-brand-block">
          <span className="site-footer-brand">Tooth Finder</span>
          <p className="site-footer-note">
            © {new Date().getFullYear()} Tooth Finder. Mould data is supplied
            by the manufacturing laboratories.
          </p>
        </div>

        <nav className="site-footer-links">
          <Link to="/home">Search moulds</Link>
          <Link to="/products">Products</Link>
          <Link to="/plans">Plans</Link>
          <Link to="/vendors">List your lab</Link>
        </nav>
      </div>
    </footer>
  );
}
